// extracted by mini-css-extract-plugin
export default {"loader":"main_loader__K34cy"};